import { render, staticRenderFns } from "./FormSelectStandard.vue?vue&type=template&id=de5b8328&"
import script from "./FormSelectStandard.vue?vue&type=script&lang=js&"
export * from "./FormSelectStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports